// const deriveUrl = "http://wisdomorg.oicp.net:8189"
// const deriveUrl = "http://127.0.0.1:8089"
const deriveUrl = "http://cqtally.co:8081"
export default {
    deriveUrl
};



// WEBPACK FOOTER //
// ./src/api/derive/derive.js